import { gql } from '@apollo/client';

const UPDATE_GROUP_PRIORITY = gql`
  mutation updateGroupPriority($groups: [GroupPriorityInput!]!) {
    updateGroupPriority(groups: $groups) 
  }
`;

export { UPDATE_GROUP_PRIORITY }
